import { render, staticRenderFns } from "./select-filter-hubs.vue?vue&type=template&id=47d47422&scoped=true&"
import script from "./select-filter-hubs.vue?vue&type=script&lang=js&"
export * from "./select-filter-hubs.vue?vue&type=script&lang=js&"
import style0 from "./select-filter-hubs.vue?vue&type=style&index=0&id=47d47422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d47422",
  null
  
)

export default component.exports